// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"b8783b63","236":"2d567c89","496":"a5ae2c1a","703":"622c08cc"}[chunkId] + ".chunk.js";
};